<template>
  <div>
    <gui-multi-select
        :modelValue="modelValue"
        @update:modelValue="e=>$emit('update:modelValue', e)"
        placeholder="Выберите роль"
        :label="label"
        :error="error"
        :hilightOn="hilightOn"
        textField="display_name"
        :w="w"
        :sm="sm"
        :list="list"/>
  </div>
</template>

<script>
export default {
  name: 'gui-role-multi-select',
  data() {
    return {
      list: [],
    }
  },
  props: {
    label: String,
    error: [String, Object, Array],
    hilightOn: [Array, String, Number],
    modelValue: {
      type: [Array],
    },
    w: Boolean,
    sm: Boolean,
  },
  mounted() {
    this.loadList();
  },
  methods: {
    loadList() {
      axiosGetValue('/api/admin/roles/widget', {}, e => {
        this.list = e
      })
    },
  }
}
</script>